<script setup lang="ts">
const { onSubmit, onReset, isSubmitting, result } = useApplyCouponForm();
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit" @reset="onReset">
    <div class="flex items-start gap-1.5">
      <FieldText name="code" type="text" label="Code promotionnel / carte cadeau" placeholder="Entrez le code ici" required hide-label />
      <UiSubmitIcon :is-submitting="isSubmitting" icon="i-lucide-send-horizontal" />
    </div>
  </UiFormWrapper>
</template>
